export default "__VITE_ASSET__Dovt7aC6__"